import { httpTokenCommon } from "../../helper/http-common";

class vendorOnboardingService {
  getVendorUserDetails(id) {
    return httpTokenCommon.get(
      `VendorManagment/GetVendorUserDetailsByMUId?muId=${id}`
    );
  }
  getCountryMaster() {
    return httpTokenCommon.get("VendorManagment/GetCountryMaster");
  }
  getLanguageMaster() {
    return httpTokenCommon.get("VendorManagment/GetLanguageMaster");
  }
  getTitleMaster() {
    return httpTokenCommon.get("VendorManagment/GetTitleMaster");
  }
  getTypeOfVendorMaster() {
    return httpTokenCommon.get("VendorManagment/GetTypeOfVendorMaster");
  }
  getRegionalCodeMaster(countryCode) {
    return httpTokenCommon.get("VendorManagment/GetRegionalCodeMaster", {
      params: { CountryCode: String(countryCode ?? "").trim() },
    });
  }

  getVendorCategoryMaster() {
    return httpTokenCommon.get("VendorManagment/GetVendorCategoryMaster");
  }
  getPurchaseGroupMaster() {
    return httpTokenCommon.get("VendorManagment/GetPurchasingGroup");
  }
  getPurchaseOrg() {
    return httpTokenCommon.get("VendorManagment/GetPurchaseOrg");
  }
  getOrderCurrency() {
    return httpTokenCommon.get("VendorManagment/GetOrderCurrency");
  }
  getPaymentTerms() {
    return httpTokenCommon.get("VendorManagment/GetPaymentTerms");
  }
  getSchemaGroup() {
    return httpTokenCommon.get("VendorManagment/GetSchemaGroup");
  }
  getPaymentMethod() {
    return httpTokenCommon.get("VendorManagment/GetPaymentMethod");
  }
  getReconciliationAccount() {
    return httpTokenCommon.get("VendorManagment/GetReconciliationAccount");
  }
  getHouseBank(companyCode) {
    return httpTokenCommon.get("/VendorManagment/GetHouseBank", {
      params: { CompanyCode: companyCode },
    });
  }
  getWithholdingTaxType(countryKey) {
    const key = String(countryKey ?? "")
      .trim()
      .replace(/[\s+]+/g, "")
      .replace(/[^A-Za-z0-9]/g, "");
    return httpTokenCommon.get(
      `VendorManagment/GetWithholdingTaxType?CountryKey=${encodeURIComponent(key)}`
    );
  }
  getTransportationZoneMaster(countryKey) {
    return httpTokenCommon.get("VendorManagment/GetTransportationZoneMaster", {
      params: { CountryKey: String(countryKey ?? "").trim() },
    });
  }
  getWithholdingTaxCode(WTaxType) {
    return httpTokenCommon.get("VendorManagment/GetWithholdingTaxCode", {
      params: { WTaxType: WTaxType },
    });
  }
  getIncoMaster() {
    return httpTokenCommon.get("VendorManagment/GetIncoMaster");
  }
  getSectionCodeMaster() {
    return httpTokenCommon.get("VendorManagment/GetSectionCodeMaster");
  }
  getExemptionMaster() {
    return httpTokenCommon.get("VendorManagment/GetExemptionMaster");
  }
  saveVendorInformation(inputData) {
    return httpTokenCommon.post(
      "VendorManagment/SaveVendorInformation",
      inputData
    );
  }
  getVendorFromDetailsByVendorId(inputData) {
    return httpTokenCommon.post(
      "VendorManagment/GetVendorFromDetailsByVendorId",
      inputData
    );
  }
  // vendor Emp dashboard
  getVendorDashboardCountAPI(inputData) {
    return httpTokenCommon.post(
      "VendorManagment/GetVendorEmployeeTileCountByMUId",
      inputData
    );
  }
  getVendorTableDataAPI(inputData) {
    return httpTokenCommon.post(
      "VendorManagment/GetEmployeeVendorTableData",
      inputData
    );
  }
  saveVendorRequest(inputData) {
    return httpTokenCommon.post("VendorManagment/VendorRequest", inputData);
  }
  VendorFormApproveRejectByRole(inputData) {
    return httpTokenCommon.post(
      "VendorManagment/VendorFormAproveRejectByRole",
      inputData
    );
  }
}

const VendorOnboardingService = new vendorOnboardingService();
export default VendorOnboardingService;
